<template>
  <section class="section pt-1 bg-white">
    <div class="container">
      <h1 class="mb-4">{{ $t("help.platform.organization-settings.text") }}</h1>

      <div role="tablist">
        <b-card no-body class="shadow-none mb-3">
          <b-card-body>
            <p class="mb-3">
              {{ $t("help.platform.organization-settings.line-1") }}
            </p>

            <img src="@/assets/images/help/organization-settings.png" class="image" />
          </b-card-body>
        </b-card>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      col: "col1",
    };
  },
  mounted() {
    setTimeout(() => {
      const { col } = this.$route.query;
      this.col = col;
      window.scrollTo({ top: 700, behavior: "smooth" });
    }, 500);
  },
};
</script>

<style scoped>
.founded {
  background: yellow !important;
}
.image {
  display: block;
  max-width: 100%;
}
</style>
